import IMAGE from 'constants/images';

export default {
  STATUS: [
    { KEY: 0, VALUE: 'INATIVO' },
    { KEY: 1, VALUE: 'ATIVO' },
  ],
  BANKS: [
    {
      KEY: 'BB',
      VALUE: '001 Banco do Brasil',
      LOGO: IMAGE.COMPANY_MANAGMENT_ICONS.BB_LOGO,
    },
    {
      KEY: 'SANTANDER',
      VALUE: '033 Banco Santander S.A.',
      LOGO: IMAGE.COMPANY_MANAGMENT_ICONS.SANTANDER_LOGO,
    },
    {
      KEY: 'SICREDI',
      VALUE: '748 Sicredi S.A.',
      LOGO: IMAGE.COMPANY_MANAGMENT_ICONS.SICREDI_LOGO,
    },
    {
      KEY: 'CAIXA',
      VALUE: '104 Caixa Econômica Federal',
      LOGO: IMAGE.COMPANY_MANAGMENT_ICONS.CAIXA_LOGO,
    },
    {
      KEY: 'CIELO',
      VALUE: 'Cielo',
      LOGO: IMAGE.COMPANY_MANAGMENT_ICONS.CIELO_LOGO,
    },
    {
      KEY: 'SITEF',
      VALUE: 'Sitef',
      LOGO: IMAGE.COMPANY_MANAGMENT_ICONS.FISERV_LOGO,
    },
    {
      KEY: 'ADYEN',
      VALUE: 'Adyen',
      LOGO: IMAGE.COMPANY_MANAGMENT_ICONS.ADYEN_LOGO,
    },
    {
      KEY: 'BRADESCO',
      VALUE: 'Banco Bradesco S.A',
      LOGO: IMAGE.COMPANY_MANAGMENT_ICONS.BRADESCO_LOGO_SVG,
    },
  ],
  EMV_BANKS: [
    {
      KEY: 'CIELO',
      VALUE: 'Cielo',
      LOGO: IMAGE.COMPANY_MANAGMENT_ICONS.CIELO_LOGO,
    },
    {
      KEY: 'VISA_PMS',
      VALUE: 'Visa PMS',
      LOGO: IMAGE.COMPANY_MANAGMENT_ICONS.VISA_LOGO,
    },
  ],
  TIME: [
    { KEY: 'MINUTES', VALUE: 'Minutos' },
    { KEY: 'HOURS', VALUE: 'Horas' },
  ],
  MIN_VALUE: [
    { KEY: 'CUSTON', VALUE: 'R$' },
    // { KEY: 'FARE_VALUE', VALUE: 'Valor Tarifa' },
  ],
  ANTIFRAUD_TYPE: [{ KEY: 'CYBERSOURCE', VALUE: 'CYBERSOURCE ' }],
  VERSION_API: [
    { KEY: '1', VALUE: 'V1' },
    { KEY: '2', VALUE: 'V2' },
  ],
  ERROR_CODE: [{ KEY: 'companyservice.createchargerequestexternal.notfound' }],
};
